import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { metaReducers, reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../environments/environment';
import { AuthStoreModule } from './auth/auth-store.module';
import { CoreStoreModule } from './core/core-store.module';
import { ReportsStoreModule } from './reports/reports-store.module';
import { CostModuleStoreModule } from './cost-module/cost-module-store.module';
import { TracksStoreModule } from './tracks/tracks-store.module';
import { UnitsStoreModule } from './units/units-store.module';
import { FuelCardStoreModule } from './fuel-card/fuel-card-store.module';
import { ZonesStoreModule } from './zones/zones-store.module';
import { ScoringStoreModule } from './scoring/scoring-store.module';
import { UserAccountsStoreModule } from './user-accounts/user-accounts-store.module';
import { MapDrawStoreModule } from './map/map-draw-store.module';

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false
      }
    }),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 100,
      logOnly: !environment.production,
      serialize: true
    }),
    CoreStoreModule,
    AuthStoreModule,
    ReportsStoreModule,
    CostModuleStoreModule,
    TracksStoreModule,
    UnitsStoreModule,
    FuelCardStoreModule,
    ZonesStoreModule,
    ScoringStoreModule,
    UserAccountsStoreModule,
    MapDrawStoreModule
  ]
})
export class StoresModule {
}
